/* eslint-disable eqeqeq */
/* eslint-disable new-cap */
/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('LordConfigsController', LordConfigsController)

  LordConfigsController.$inject = ['NotificationService', 'FoundationApi', 'UserService']

  function LordConfigsController (NotificationService, FoundationApi, UserService) {
    const vm = this

    // functions
    vm.setUser = setUser
    vm.openConfirmModal = openConfirmModal
    vm.confirmModal = confirmModal
    vm.closeConfirmModal = closeConfirmModal

    getLordsOrNewwayUsers()

    function setUser (user) {
      vm.userId = user.id
      vm.userEmail = user.email
      vm.userName = user.name
      vm.userCompany = user.company_id
      vm.userProfile = user.profile.name
      vm.createdAt = user.created_at
      vm.showUserList = false
    }

    function getLordsOrNewwayUsers () {
      UserService
        .getUsersToTurnThemIntoLord()
        .$promise
        .then(function (data) {
          vm.lordList = data
        })
        .catch(function () {
          NotificationService.errorHandler('', 'Erro ao obter usuários LORD e NEW WAY')
        })
    }

    function openConfirmModal (user) {
      setUser(user)
      if (!vm.userEmail || !vm.userId) {
        NotificationService.warningHandler('', 'É necessário selecionar um usuário')
        return false
      }
      const regexPattern = RegExp('gruponewway.com.br')
      if (!regexPattern.exec(vm.userEmail)) {
        NotificationService.warningHandler('', 'Apenas usuários NEW WAY podem ser LORD')
        return false
      }
      FoundationApi.publish('confirmModal', 'open')
    }

    function confirmModal () {
      updateUserRole(vm.userId)
    }

    function closeConfirmModal () {
      FoundationApi.publish('confirmModal', 'close')
    }

    function updateUserRole (userId) {
      UserService
        .updateUserRoleByUserId({ userId })
        .$promise
        .then(function (data) {
          if (data.success) {
            getLordsOrNewwayUsers()
            NotificationService.successHandler('', 'Role atualizada com sucesso')
          }
        })
        .catch(function () {
          NotificationService.errorHandler('', 'Erro ao atualizar role')
        })
      FoundationApi.publish('confirmModal', 'close')
    }
  }
  // eslint-disable-next-line semi
})();
